/**
 * ProtectedRoute Component
 *
 * A route guard that checks for valid authentication before rendering
 * child components. If the user is not authenticated (no login response
 * in Redux store), they are redirected to the login page.
 *
 * SECURITY FIX: This replaces the previously disabled auth check in
 * PageWrapper.tsx which had the navigate call commented out.
 *
 * Usage:
 *   <ProtectedRoute><LANDING.DASHBOARD /></ProtectedRoute>
 */
import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectLoginResponse } from '../redux/login/login.selector';
import { loginPages } from '../menu';

interface IProtectedRouteProps {
	children: ReactNode;
}

const ProtectedRoute: React.FC<IProtectedRouteProps> = ({ children }) => {
	// Check if user has an active login session in Redux store
	const loginResponse = useSelector(selectLoginResponse);

	// If no login response exists, redirect to login page
	if (!loginResponse) {
		return <Navigate to={loginPages.login.path} replace />;
	}

	// User is authenticated - render the protected content
	return <>{children}</>;
};

export default ProtectedRoute;
